import { render, staticRenderFns } from "./Counsellors.vue?vue&type=template&id=bf7f4ec2&"
import script from "./Counsellors.vue?vue&type=script&lang=js&"
export * from "./Counsellors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports